export default __webpack_public_path__ + "cardModelNlp-alla8d131.png";